export const STEPS = {
  ECOMM_PLATFORM: 'ECOMM_PLATFORM',
  STORE_DETAILS: 'STORE_DETAILS'
};
